import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=4c54708e&scoped=true&"
import script from "./UpdateButton.vue?vue&type=script&lang=ts&"
export * from "./UpdateButton.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateButton.vue?vue&type=style&index=0&id=4c54708e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54708e",
  null
  
)

export default component.exports